import * as React from 'react';

import { Page } from './page/page';

export class App extends React.Component {
  public render() {
    return <Page />;
  }
}
